import types from './actionTypes';

const initialState = {
  loading: false,
  invoices: [],
  error: '',
};

const invoicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_INVOICES_STATE:
      return initialState;
    case types.FETCH_INVOICES_BY_USER.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case types.FETCH_INVOICES_BY_USER.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        invoices: action.invoices,
      };
    case types.FETCH_INVOICES_BY_USER.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default invoicesReducer;
